import { NetworkRequestException } from '../exceptions/networkRequestException';

export function defaultErrorToTerm(exception: unknown): string | null {
  if (
    !(exception instanceof NetworkRequestException) ||
    exception.messageKey === undefined
  ) {
    return null;
  }

  // Here are listed the available error translation keys.
  switch (exception.messageKey) {
    case 'exception.rundeck.too_many_requests':
    case 'exception.rundeck.timeout':
    case 'exception.rundeck.forbidden':
    case 'exception.rundeck.unauthorized':
    case 'exception.rundeck.client_error':
    case 'exception.rundeck.server_error':
    case 'exception.environment.already_in_maintenance':
    case 'exception.environment.mono_vm_cannot_be_scalable':
    case 'exception.environment.not_deletable':
    case 'exception.environment.not_in_maintenance':
    case 'exception.environment.not_running':
    case 'exception.job.toggle_vm.forbidden.for_prod':
      return exception.messageKey;
    default:
      return null;
  }
}
